import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchMeetingTags(ctx, queryParams) {
        return new Promise((resolve, reject) => {
          axiosIns.get('/meeting_tag/list', {params:queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
        })
    },
    fetchMeetingTag(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns.get(`/meeting_tag/${id}`)
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    addMeetingTag(ctx, data) {
        return new Promise((resolve, reject) => {
            axiosIns.post('/meeting_tag', data)
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
    }

  },
}
